module.exports = __webpack_public_path__ + "static/media/xgraph.a939699c.svg";